export const ASSISTANT_PATH = '/pro/assistant';
export const assistantConversationPath = (id: string) => `${ASSISTANT_PATH}?conversation_id=${id}`;

export const GUIDE_NAVIGATION = {
  orientation: { pages: ['inbox', 'activity', 'patients', 'stats'], related: 'patients' },
  sent: { pages: ['sent'], related: 'read' },
  resolve: { pages: ['inbox'], related: 'sent' },
  reminders: { pages: ['stats'], related: 'stats' },
  history: { pages: [], related: 'orientation' },
  patients: { pages: ['patients', 'activity'], related: 'search' },
  search: { pages: ['patients'], related: 'filters' },
  filters: { pages: ['patients'], related: 'missing' },
  missing: { pages: ['patients'], related: 'filters' },
  appointments: { pages: ['activity'], related: 'patients' },
  stats: { pages: ['stats'], related: 'missing' },
  message: { pages: ['patients'], related: 'read' },
  share: { pages: ['inbox'], related: 'external' },
  dictate: { pages: ['inbox'], related: 'microphone' },
  external: { pages: ['inbox'], related: 'share' },
  read: { pages: ['patients'], related: 'inbox' },
  microphone: { pages: ['inbox'], related: 'dictate' },
  inbox: { pages: ['inbox'], related: 'message' },
  documents: { pages: ['patients'], related: 'message' },
} as const;

export type HelpTopic = keyof typeof GUIDE_NAVIGATION;
export type HelpGuide = Record<HelpTopic, { question: string; answer: string }>;
